// ad-card — forum_list_card 广告单卡(受控:调用方传入 ad + position)。
// 无 ad → 渲染占位卡。180×180 封面 + "广告"角标。
// 对应 .pen 节点 OpszT(瀑布流卡片,封面 ~180×180 + 角标 + 标语)。
//
// useForumCardAds — 供父组件(forum 瀑布流)调用,返回 visible: Ad[] 长度 ≤ 4。
import { useState, useEffect } from 'react'
import { AD_CAP } from '../../_lib/ad-slot'
import type { Ad } from '../../_lib/ad-rotate'
import { computeVisible } from '../../_lib/ad-rotate'
import { useAdFeed } from '../../_lib/ad-api'
import { getForumIdentity } from '../../_lib/forum-device-id'
import { trackAndOpen } from './track-click'
import { AdPlaceholder } from './ad-placeholder'

const SLOT = 'forum_list_card'
const CAP = AD_CAP[SLOT]

/** useForumCardAds — 拉取 forum_list_card 广告,返回轮转后的 visible 列表(长度 ≤ 4)。 */
export function useForumCardAds(): Ad[] {
  const { data } = useAdFeed(SLOT)
  const [visible, setVisible] = useState<Ad[]>([])

  useEffect(() => {
    if (!data) return
    const identity = getForumIdentity()
    computeVisible(data.ads, data.order_mode, identity, CAP)
      .then(setVisible)
      .catch(() => setVisible([]))
  }, [data])

  return visible
}

/** AdCard — 受控单卡。无 ad 时渲染占位卡。 */
export function AdCard({ ad, position }: { ad?: Ad; position: number }) {
  if (!ad) {
    return (
      <div data-testid={`ad-card-${position}`}>
        <AdPlaceholder variant="card" />
      </div>
    )
  }

  return (
    <button
      type="button"
      data-testid={`ad-card-${position}`}
      className="relative overflow-hidden rounded-xl"
      onClick={() => trackAndOpen(ad.id, SLOT, position, ad.target_url)}
    >
      <img src={ad.image_url} alt="广告" className="h-[180px] w-[180px] bg-white object-contain" />
      <span className="absolute left-1 top-1 rounded bg-black/40 px-1 py-0.5 text-[10px] text-white">
        广告
      </span>
      {ad.slogan && (
        <p className="line-clamp-2 px-2 py-1.5 text-[14px] leading-snug text-[#1A1A1A]">
          {ad.slogan}
        </p>
      )}
    </button>
  )
}
